export default "__VITE_ASSET__DTzvHqv5__"